import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { Col, Container } from "react-bootstrap";
import POOLBAN_PAYMENT from "assets/poolban-payment.png";
import POOLBAN_SECURITY from "assets/poolban-security.png";
import POOLBAN_MAIN_IMAGE from "assets/poolban-main.png";
import { BackgroundAnimation } from "./background-animation";
import { CARDS_CONTEXT } from "../constant";
import styles from "./landing.module.scss";
export const Landing = () => {
  const cardsRef = useRef(null);
  const { scrollYProgress } = useScroll();
  const scale = useTransform(scrollYProgress, [0, 0.1], [1, 1.1]);
  const cardVariants = {
    offscreen: {
      y: 50,
    },
    onscreen: {
      y: 0,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  };

  return (
    <div className={styles.landing_container}>
      <BackgroundAnimation />
      <div
        className="container text-center py-md-5 mt-md-Fy-md-55 d-flex flex-column align-items-center gap-4"
        style={{ position: "relative", zIndex: 100 }}
      >
        <motion.div className={styles.title} style={{ scale }}>
          <h1> پولبان ــــ بستر امن پرداختهای اينترنتی و موبايلي</h1>
          <h2>دارای مجوز رسمی پرداخت ياری از بانک مرکزی جمهوری اسلامی ايران</h2>
        </motion.div>

        <Link to="/login/">
          <button className={"primary-btn my-4 primary-btn-md fs-6 "}>
            ورود
          </button>
        </Link>
      </div>
      <div className="d-flex justify-content-center align-items-center m-md-1 position-relative">
        <BackgroundAnimation />
        <img
          src={POOLBAN_MAIN_IMAGE}
          alt="poolban.ir"
          className={styles.poolban_main_image}
        />
      </div>
      <div className={styles.cards_container} ref={cardsRef}>
        {CARDS_CONTEXT.map((item) => {
          return (
            <Col key={item.title}>
              <motion.div
                className={styles.card}
                initial="offscreen"
                whileInView="onscreen"
                variants={cardVariants}
              >
                {item.icon}
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </motion.div>
            </Col>
          );
        })}
      </div>
      <div className={styles.box_container}>
        <Container>
          <h1> درگاه پرداخت اينترنتی و موبايلی پولبان </h1>
          <p dir="rtl">
            پولبان ابزار مديريت تراکنشهای مالی را در اختيار صاحب درگاه قرار مي
            دهد و با امکان تعريف مدل تراکنش اشتراکی امکان تسهيم سهم تراکنش در
            تسويه حسابهای روزانه را برای مشتريان فراهم نموده است.{" "}
          </p>
        </Container>
      </div>
      <Container>
        <div className="my-4">
          <div className="container w-100 d-flex align-items-center justify-content-between gap-3 flex-row-reverse">
            <motion.div
              initial={{ scale: 0, x: -200 }}
              whileInView={{ scale: 1.2, x: 0 }}
              transition={{ duration: 0.4 }}
            >
              <img
                src={POOLBAN_SECURITY}
                width={450}
                alt="poolban.ir"
                className="d-none d-md-flex"
              />
            </motion.div>

            <div className="d-flex flex-column gap-2 rtl text-end">
              <h3 className="font-bold m-0">
                امنيت پرداخت بر بستر درگاره پرداخت الکترونيک پولبان
              </h3>
              <p className="d-flex align-items-bottom py-2" dir="rtl">
                استفاده از ابزارهای رمزنگاری پيشرفته در کل زنجيره انجام تراکنش
                ضامن امنيت اطلاعات شخصی کاربران و شفافيت و امنيت انتقال پول بين
                حساب مبدأ و مقصد است.{" "}
              </p>
            </div>
          </div>
          <br className="d-none d-md-block " />
          <br className="d-none d-md-block " />
          <div className="container w-100 d-flex  align-items-center justify-content-between gap-3 my-1">
            <motion.div
              initial={{ x: 400 }}
              whileInView={{ x: 50 }}
              transition={{ duration: 0.4 }}
            >
              <img
                src={POOLBAN_PAYMENT}
                alt="poolban.ir"
                className="d-none d-md-flex"
              />
            </motion.div>
            <div className="d-flex flex-column gap-2 rtl text-end">
              <h2 className="font-bold m-0"> مسيردهی هوشمند </h2>
              <p className="d-flex align-items-bottom py-2 " dir="rtl">
                پولبان با انعقاد قرارداد همکاری با شرکتهای معتبر PSP کشور در هر
                لحظه از زمان با انتخاب بهترين و سريعترين سرويس، مسير انجام
                تراکنش بانکی را به صورت بهينه تعيين و هدايت می کند.{" "}
              </p>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
